import * as React from "react";
import { AppRoutes } from "./routes";

export function App() {
  return (
      <AppRoutes />
  );
}
